import { CMSPage, CMSSection } from "../../models";
import { replacer } from "./replacer";

export function findSection<TypedSection extends CMSSection>(type: TypedSection['type']) {
    return (section: CMSSection): section is TypedSection => section.type === type && section.enabled !== false
}

export function isSection<TypedSection extends CMSSection>(section: CMSSection, type: TypedSection['type']): section is TypedSection {
    return section.type === type && section.enabled !== false
}

export function pageReplacer<TypedPage extends CMSPage>(page: TypedPage, params: Record<string, string>) {
    const _page: TypedPage = JSON.parse(JSON.stringify(page))


    sectionReplacer(_page, params)

    if (_page.banner) {
        sectionReplacer(_page.banner, params)
    }

    if (_page.sections?.length) {
        sectionsReplacer(_page.sections, params)
    }

    return _page
}

export function sectionsReplacer<TypedSection extends CMSSection>(sections: TypedSection[], params: Record<string, string>) {
    const _sections: TypedSection[] = [...sections]
    for (let i = 0; i < _sections.length; i++) {
        const section = _sections[i];
        _sections[i] = sectionReplacer(section, params)
    }
    return _sections
}

export function sectionReplacer<TypedSection extends CMSSection>(section: TypedSection, params: Record<string, string>) {
    const _section: TypedSection = JSON.parse(JSON.stringify(section))
    if (_section.title) _section.title = replacer(_section.title, params)
    if (_section.subTitle) _section.subTitle = replacer(_section.subTitle, params)
    if (_section.text) _section.text = replacer(_section.text, params)
    if (_section.sections?.length) _section.sections = sectionsReplacer(_section.sections, params)
    if (_section.cta?.length) {
        for (const cta of _section.cta) {
            if (cta.title) cta.title = replacer(cta.title, params)
            if (cta.text) cta.text = replacer(cta.text, params)
        }

    }
    return _section
}
